import { Skeleton } from '@sunwebgroup/uds-ui/skeleton'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from 'react-intl'
import { useCMSPageField } from '@/cms/fields'
import getUserRatingLabelIntlId from '@/scopes/common/components/utils/getUserRatingLabelIntlId'
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import styles from './Rating.module.css'

export function Rating() {
  const intl = useIntl()
  const ratingsCount = useCMSPageField('userReviews.ratingsCount')
  const ratingAverage = useCMSPageField('userReviews.ratingAverage')

  const { reviewsAmount, isLoading } = useUserReviewsInitialData()
  const displayedReviewsAmount = reviewsAmount || ratingsCount

  if (!ratingAverage)
    return null

  if (isLoading) {
    return (
      <div className={styles.wrapper}>
        <Skeleton className={styles.ratingScoreSkeleton} />
        <div className={styles.labelWrapperSkeleton}>
          <Skeleton className={styles.labelSkeleton} />
          <Skeleton className={styles.labelSkeleton} />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.ratingWrapper}>
        <Typography variant="display-f-regular">{ratingAverage}</Typography>
      </div>
      <div className={styles.labelWrapper}>
        <Typography variant="display-f-regular" className={styles.ratingLabel}>
          {intl.formatMessage({ id: getUserRatingLabelIntlId(ratingAverage) })}
        </Typography>
        <Typography variant="body-m-regular-tight" className={styles.amountLabel}>
          {intl.formatMessage({ id: 'reviews_score_amount_label' }, { amount: displayedReviewsAmount })}
        </Typography>
      </div>
    </div>
  )
}
